import { OnChanges, Component, OnInit, SimpleChanges, HostListener, NgZone, ViewChild, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { environment } from "../../environments/environment";
import { Storage } from 'aws-amplify';
import { ConstantsService } from "../services/constants.service";
import { DataService } from '../services/data.service';
import { UrlConstants } from '../services/url-constants';
import { DeviceDetectorService } from 'ngx-device-detector';
import * as uuid from 'uuid';
import { CacheService } from '../services/cache.service';
import { UserService } from '../services/user.service';
import { Title } from '@angular/platform-browser';
import { SharedMixpanelService } from '../services/shared-mixpanel.service';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';
// import { HelperService } from '../services/helper.service';

@Component({
  selector: 'app-submit',
  templateUrl: './submit.component.html',
  styleUrls: ['./submit.component.scss']
})
export class SubmitComponent implements OnInit, OnDestroy {
  maxDate
  public selectedTag: string;
  public tcAccepted = false;
  public from = this.constants.SUBMIT_SMALL_TXT
  public newFrom = this.constants.SUBMIT_SMALL_TXT;
  public progressLoading = [];
  public isDisable = false;
  public isCreator: any;
  public currentAuthUser: string;
  public currentAuthUserEmail: string;
  public givenName: string;
  public isPortrait = false;
  public memberId;
  public collabYes = false;
  public collabNo = false
  public tagList = this.constants.TAG_LIST
  public fileUrl: string;
  public errorMsg: boolean;
  public submitForm: UntypedFormGroup;
  public files: File[] = [];
  public userName: string;
  public profilePicture: string;
  defaultTime = "10:35PM";
  screenHeight: number;
  screenWidth: number;
  windowWidth: string;
  isPrime: any;
  login: boolean
  hideText = true
  convertedDate: number;
  public showRetyForMobile: boolean = false;
  public nicknameValidationError: boolean = false;
  public locationValidationError: boolean = false;
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 576 && this.screenWidth < this.screenHeight) {
      this.windowWidth = `${this.screenHeight}px`;
    }
  }
  constructor(
    private urlConstants: UrlConstants,
    public constants: ConstantsService,
    private dataService: DataService,
    private fb: UntypedFormBuilder,
    private authenticate: CacheService,
    private deviceService: DeviceDetectorService,
    private userService: UserService,
    private router: Router,
    public title: Title,
    private mixpanel: SharedMixpanelService,
    private zone: NgZone,
    // private helperService:HelperService
  ) {
    this.errorMsg = false;
  }

  ngOnInit(): void {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.addGlobalStyle('.publift-widget-23174194645-container,.publift-widget-23196941527-container { display: none !important}');
    this.authcall();
    this.onResize();
    this.title.setTitle(this.constants.TITLE.submit);
    this.getUser()
    this.initialiaseFrom();
    if (window.outerWidth < window.outerHeight) {
      this.isPortrait = true;
    }

    const today = new Date().toISOString().split('T')[0];
    this.maxDate = today;
  }

  ngOnDestroy(): void {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.removeGlobalStyle();
  }

  async onSelect(event) {
    const FILE = event.addedFiles[0];
    this.files.push(...event.addedFiles);
    if (this.files.length !== 0) {
      this.from = `${this.constants.SUBMIT_SMALL_TXT}-1`;
      document.getElementById("section-error").style.display = "none";
      document.getElementById("error-video-potrait-mob").style.display = "none";
      document.getElementById("error-video-length-mob").style.display = "none";
      document.getElementById("error-video-lowres-mob").style.display = "none";
    }
    const videoUrl = URL.createObjectURL(FILE);
    this.getVideoOrientation(videoUrl);
  }

  async getVideoOrientation(videoUrl) {
    var video = document.createElement("video");
    video.preload = 'metadata';
    video.src = videoUrl;
    video.onloadedmetadata = async function() {
        const videoWidth = video.videoWidth;
      const videoHeight = video.videoHeight;
      if (video.duration < 180.00) {
        document.getElementById("section-no-error").style.display = "none";
        document.getElementById("error-video-potrait").style.display = "none";
        document.getElementById("error-video-potrait-image").style.display = "none";
        document.getElementById("error-video-lowres").style.display = "none";
        document.getElementById("error-video-lowres-image").style.display = "none";
        document.getElementById("section-error").style.display = "flex";
        document.getElementById("error-video-length").style.display = "block";
        document.getElementById("error-video-length-image").style.display = "initial";
        if (window.innerWidth < 600) {
          document.getElementById("section-error").style.display = "none";
          document.getElementById('background').style.backgroundColor = '#CA7358';
          document.getElementById('nav').style.backgroundColor = '#CA7358';
          document.getElementById("nav").style.display = "none";
          document.getElementById("nav-mob").style.display = "flex";
          document.getElementById('nav-mob').style.backgroundColor = '#CA7358';
          document.getElementById("mob-error").style.display = "flex";
          document.getElementById("mob-error").style.flexDirection = "column";
          document.getElementById("mob-error").style.justifyContent = "space-between";
          document.getElementById("second").style.fontSize = "16px";
          document.getElementById("error-video-potrait-mob").style.display = "none";
          document.getElementById("error-video-lowres-mob").style.display = "none";
          document.getElementById("error-video-length-mob").style.display = "block";
          document.getElementById("error-video-potrait-mob-image").style.display = "none";
          document.getElementById("error-video-lowres-mob-image").style.display = "none";
          document.getElementById("error-video-length-mob-image").style.display = "initial";
          // button
          document.getElementById("okay").style.background = "#265D6E";
          document.getElementById("okay").style.borderRadius = "20px";
          document.getElementById("okay").style.fontFamily = "Graphik";
          document.getElementById("okay").style.color = "#F2EFEB";
          document.getElementById("okay").style.fontSize = "15px";
          document.getElementById("okay").style.border = "0";
          document.getElementById("okay").style.width = "100%";
          document.getElementById("okay").style.height = "45px";
          // 
        } else {
          document.getElementById("nav").style.display = "flex";
          document.getElementById("nav-mob").style.display = "none";
        }
        return;
      }
      if (video.videoWidth < video.videoHeight) {
        document.getElementById("section-no-error").style.display = "none";
        document.getElementById("error-video-length").style.display = "none";
        document.getElementById("error-video-length-image").style.display = "none";
        document.getElementById("error-video-lowres").style.display = "none";
        document.getElementById("error-video-lowres-image").style.display = "none";
        document.getElementById("section-error").style.display = "flex";
        document.getElementById("error-video-potrait").style.display = "block";
        document.getElementById("error-video-potrait-image").style.display = "initial";
        if (window.innerWidth < 600) {
          document.getElementById("section-error").style.display = "none";
          document.getElementById('background').style.backgroundColor = '#CA7358';
          document.getElementById('nav').style.backgroundColor = '#CA7358';
          document.getElementById("nav").style.display = "none";
          document.getElementById("nav-mob").style.display = "flex";
          document.getElementById('nav-mob').style.backgroundColor = '#CA7358';
          document.getElementById("mob-error").style.display = "flex";
          document.getElementById("mob-error").style.flexDirection = "column";
          document.getElementById("mob-error").style.justifyContent = "space-between";
          document.getElementById("second").style.fontSize = "16px";
          document.getElementById("error-video-length-mob").style.display = "none";
          document.getElementById("error-video-lowres-mob").style.display = "none";
          document.getElementById("error-video-potrait-mob").style.display = "block";
          document.getElementById("error-video-length-mob-image").style.display = "none";
          document.getElementById("error-video-lowres-mob-image").style.display = "none";
          document.getElementById("error-video-potrait-mob-image").style.display = "initial";
          // button
          document.getElementById("okay").style.background = "#265D6E";
          document.getElementById("okay").style.borderRadius = "20px";
          document.getElementById("okay").style.fontFamily = "Graphik";
          document.getElementById("okay").style.color = "#F2EFEB";
          document.getElementById("okay").style.fontSize = "15px";
          document.getElementById("okay").style.border = "0";
          document.getElementById("okay").style.width = "100%";
          document.getElementById("okay").style.height = "45px";
          // 
        } else {
          document.getElementById("nav").style.display = "flex";
          document.getElementById("nav-mob").style.display = "none";
        }
        return;
      }
      if (videoWidth < 600 && videoHeight < 400) {
        document.getElementById("section-no-error").style.display = "none";
        document.getElementById("error-video-potrait").style.display = "none";
        document.getElementById("error-video-potrait-image").style.display = "none";
        document.getElementById("error-video-length").style.display = "none";
        document.getElementById("error-video-length-image").style.display = "none";
        document.getElementById("section-error").style.display = "flex";
        document.getElementById("error-video-lowres").style.display = "block";
        document.getElementById("error-video-lowres-image").style.display = "initial";
        if (window.innerWidth < 600) {
          document.getElementById("section-error").style.display = "none";
          document.getElementById('background').style.backgroundColor = '#CA7358';
          document.getElementById('nav').style.backgroundColor = '#CA7358';
          document.getElementById("nav").style.display = "none";
          document.getElementById("nav-mob").style.display = "flex";
          document.getElementById('nav-mob').style.backgroundColor = '#CA7358';
          document.getElementById("mob-error").style.display = "flex";
          document.getElementById("mob-error").style.flexDirection = "column";
          document.getElementById("mob-error").style.justifyContent = "space-between";
          document.getElementById("second").style.fontSize = "16px";
          // button
          document.getElementById("okay").style.background = "#265D6E";
          document.getElementById("okay").style.borderRadius = "20px";
          document.getElementById("okay").style.fontFamily = "Graphik";
          document.getElementById("okay").style.color = "#F2EFEB";
          document.getElementById("okay").style.fontSize = "15px";
          document.getElementById("okay").style.border = "0";
          document.getElementById("okay").style.width = "100%";
          document.getElementById("okay").style.height = "45px";
          // 
          document.getElementById("error-video-potrait-mob").style.display = "none";
          document.getElementById("error-video-length-mob").style.display = "none";
          document.getElementById("error-video-lowres-mob").style.display = "block";
          document.getElementById("error-video-potrait-mob-image").style.display = "none";
          document.getElementById("error-video-length-mob-image").style.display = "none";
          document.getElementById("error-video-lowres-mob-image").style.display = "initial";
        } else {
          document.getElementById("nav").style.display = "flex";
          document.getElementById("nav-mob").style.display = "none";
        }
        return;

      }      
    };
  }
  goback() {
    this.files.length = 0;
    document.getElementById("mob-error").style.display = "none";
    this.from = this.constants.SUBMIT_SMALL_TXT;
    document.getElementById('nav-mob').style.backgroundColor = '#d99671';
    document.getElementById('background').style.backgroundColor = '#d99671';
    document.getElementById("section-error").style.display = "none";
  }
  async getUser() {
    await this.authenticate.getAuthUser()
      .then(async data => {
        let { email, given_name, picture, userName } = data
        this.givenName = given_name
        this.currentAuthUser = userName
        this.userName = email
        this.profilePicture = picture
        this.currentAuthUserEmail = email
        await this.userService.getUser(false)
          .then(data => {
            let { member_id, isCreator, pictureUrl } = data
            this.profilePicture = pictureUrl === undefined ? this.profilePicture : pictureUrl;
            isCreator === undefined ? this.isCreator = false : this.isCreator = true;
            this.memberId = member_id
          })
      })
  }
  initialiaseFrom(): void {
    this.submitForm = this.fb.group({
      nickName: new UntypedFormControl('', [Validators.required, Validators.maxLength(25)]),
      location: new UntypedFormControl('', [Validators.required, Validators.maxLength(25)]),     
      country: new UntypedFormControl('', Validators.required),
      timeRecording: new UntypedFormControl('', Validators.required),
      dateRecording: new UntypedFormControl('', Validators.required),

      tags: this.fb.group({
        Animals: false,
        Rain: false,
        Snow: false,
        City: false,
        Nature: false,
        Night: false,
        Day: false,
        Interior: false,
        Water: false
      }),
      collabs: this.fb.group({
        Yes: false,
        No: false
      }),
      terms: new UntypedFormControl(false, Validators.requiredTrue)

    })
  }

  async submitform(event) {
    if (this.submitForm.get('nickName').value?.trim() === '' || !this.submitForm.get('nickName').value) {
      this.nicknameValidationError = true;
      this.isDisable = false;
      return;
    }
    if (this.submitForm.get('location').value?.trim() === '' || !this.submitForm.get('location').value) {
        this.locationValidationError = true;
        this.isDisable = false;
        return;
    }
    this.locationValidationError = false;
    this.nicknameValidationError = false;
    if (document.getElementById('progress-title').style.color === 'red') {
      this.from = `${this.constants.SUBMIT_SMALL_TXT}`;
      this.initialiaseFrom();
      console.log(this.submitForm.value);
      this.router.navigate(['/submit']);
      return;
    }
    const isMobile = this.deviceService.isMobile();
    let collabValue;
    if (Object.values(this.submitForm.value.collabs)[0]) {
      collabValue = true
    }
    else {
      collabValue = false
    }
    const months = this.constants.MONTHS_LIST
    let current_datetime = new Date()
    let formatted_date = months[current_datetime.getMonth()] + " " + current_datetime.getDate() + " " + current_datetime.getFullYear()
    const uniqueId = uuid.v4();
    event.preventDefault
    this.isDisable = true;
    var fileType = this.files[0].type
    var file = this.files[0]
    var blob = file.slice(0, file.size, fileType);
    var newFile = new File([blob], `${uniqueId}${this.constants.MP4_TXT}`, { type: fileType });
    var progressLoading;
    if (isMobile && this.isPortrait) {
      document.getElementById("style-mobile").style.display = "block"
      document.getElementById("mobile-cancel").style.display = "flex"
      document.getElementById("mobile-form").style.display = "none"
      document.getElementById("message-mobile").style.display = "none"
    }
    document.getElementById("plus-icon").style.display = "none"
    document.getElementById("progress-bar-background").style.visibility = "visible"
    document.getElementById("progress-button").style.background = "#CA7358"
    document.getElementById("progress-button").innerHTML = `Uploading!`;
    document.getElementById("progress-button").style.border = 'none';
    document.getElementById("progress-button").style.color = "#ffffff"
    document.getElementById('progress-title').innerHTML = 'Please wait...'
    document.getElementById('progress-title').style.fontFamily = 'Graphik';
    document.getElementById('progress-title').style.fontSize = '14px';
    this.hideText = false
    this.showRetyForMobile = false;

    try {
      var response = await Storage.put(`uploadedToVimeo/${newFile.name}`, newFile, {
        bucket: `${environment.VIDEO_BUCKET}`,
        contentType: `${fileType}`,
        progressCallback(progress) {
          progressLoading = (Math.floor(progress.loaded * 100 / progress.total));
          document.getElementById("progressSpan").innerHTML = `${progressLoading}%`;
          document.getElementById('progressbar').style.width = `${progressLoading}%`;
          document.getElementById('progress-title').innerHTML = '<p>Your window is now uploading.</p> <p>This may take a while.</p>';
          document.getElementById('progress-title').style.fontFamily = 'Graphik';
          document.getElementById('progress-title').style.fontSize = '14px';
          document.getElementById('progress-title').style.lineHeight = '5px';
          document.getElementById('progress-title').style.fontStyle = 'normal';
          document.getElementById('progress-title').style.fontWeight = 'normal';
        },
      })

    } catch (error) {
      response = undefined;
    }
    if (response != undefined && response['key'] == `uploadedToVimeo/${newFile.name}`) {
      document.getElementById('progress-title').innerHTML = 'Upload complete!'
      this.isDisable = false;
      if ( !this.isCreator) {

        const params = [
          { param: '{object}', value: this.constants.USER_TXT },
        ];
        const bodyObj = {
          "isCreator": this.constants.TRUE_TXT,
          "userName": this.currentAuthUser
        }
        await this.dataService.postData(this.urlConstants.getUri(this.urlConstants.updateItem, params), JSON.stringify(bodyObj)).toPromise();
      }
      const params = [
        { param: '{object}', value: this.constants.SMALL_SUBMIT_TXT },
      ];
      if (this.submitForm.value.dateRecording) {
        const dateStr = this.submitForm.value.dateRecording;
        this.convertedDate = Date.parse(dateStr) / 1000;

      }
      const dateStr = this.submitForm.value.dateRecording;
      this.convertedDate = Date.parse(dateStr) / 1000;

      const bodyObj = {
        "commonKey": this.constants.VIDEO_COMMON_KEY,
        "videoName": newFile.name,
        "videoStatus": this.constants.STATUS_TXT.PENDING_TXT,
        "nickName": this.submitForm.value.nickName.trim(),
        "cityLocation": this.submitForm.value.location.trim(),
        "timeRecording": this.submitForm.value.timeRecording,
        "dateRecording": this.convertedDate,
        "country": this.submitForm.value.country,
        "tag": this.submitForm.value.tags,
        "collab": collabValue,
        "emailId": this.userName,
        "message": this.constants.THIS_IS_IN_PENDING_TXT,
        "uploadedOn": formatted_date,
        "videoTitle": `${this.submitForm.value.nickName.trim()} - ${this.submitForm.value.location.trim()}, ${this.submitForm.value.country}`,
        "creatorName": this.givenName,
        "fileName": file.name,
        "profilePicture": this.profilePicture,
        "memberId": this.memberId,
        "videoFolder": this.constants.STATUS_TXT.UPLOADEDTOVIEO_TXT
      }
      try {
        this.mixpanel.actions.track("Submitted Window", {
          "Video name": bodyObj.videoTitle,
          "Country": bodyObj.country,
          "City": bodyObj.cityLocation,
          "timeRecording": bodyObj.timeRecording,
          "dateRecording": bodyObj.dateRecording,
          "Email": this.userName,
          "uploadedOn": bodyObj.uploadedOn,
          "memberId": bodyObj.memberId,
          "collab": bodyObj.collab,
          "Name": bodyObj.nickName,
          "User Name": bodyObj.creatorName,
          "Tag": bodyObj.tag,
        });
        await this.dataService.postData(this.urlConstants.getUri(this.urlConstants.createItem, params), JSON.stringify(bodyObj)).toPromise();
        if( !this.isCreator){
          this.from = "submit-step3";
        }else {
          this.from = "submit-step4";
        }
      } catch (e) {
        document.getElementById('progress-title').style.color = 'red'
        document.getElementById('progress-title').innerHTML = 'Same video exist <br> Please change the name'
        this.isDisable = false;
      }

    } else {
      if (isMobile && this.isPortrait) {
        this.showRetyForMobile = true;
      }
      this.isDisable = false;
      document.getElementById("progressSpan").innerHTML = '0%';
      document.getElementById('progressbar').style.width = '0%';
      document.getElementById('progress-title').innerHTML = 'Upload failed please try again';
      document.getElementById("progress-button").innerHTML = `Re-upload`;
    }
  }
  collabOnchange(event) {
    event ? `${this.collabYes = !this.collabYes} ${this.collabNo = false}` : `${this.collabNo = !this.collabNo} ${this.collabYes = false}`
  }
  setTag(tagAtcive) {
    this.tagList[tagAtcive] = !this.tagList[tagAtcive]
  }
  public async authcall() {
    this.authenticate.getAuthUser()
      .then(async (data) => {
        let { login } = data;
        this.login = login;
        if (login) {
          await this.userService.getUser(true).then(async data => {
            let { isPrime } = data;
            this.isPrime = isPrime === undefined ? true : isPrime;
          })
        }
        else {
          this.isPrime = false
        }
      })
  }

  async logout() {
    try {
      await await Auth.signOut()
      this.userService.userData = undefined;
      this.userService.isFirstCall = true;
      this.mixpanel.actions.reset()
      this.zone.run(() => this.router.navigate(['/login']));
    } catch (error) {
      if (error.code === 'NotAuthorizedException') {
        console.error('Access Token has been revoked. Please log in again.');
        localStorage.clear();
        // Optionally redirect to login or show a message to the user
        this.router.navigate(['/login']);
      } else {
        console.error('Error signing out:', error);
      }
    }
  }

  Takemetoprime() {
    if (!this.login) {
      this.router.navigate(['/signup']);
      localStorage['fromwindowBookmark'] = JSON.stringify(true);
      localStorage['fromwindowBookmark-CurrentVideo'] = JSON.stringify([this.authenticate.get()]);
    }
    else {
      this.router.navigate(['/pricing']);
    }
  }
}



